import styles from './GpsrInfo.module.scss'
import { GpsrModel } from '@/types/api'
import React from 'react'
import PhoneIcon from '@/assets/svg/phone.svg'
import EmailIcon from '@/assets/svg/email.svg'
import GlobeIcon from '@/assets/svg/globe.svg'
import MapPinIcon from '@/assets/svg/map-pin.svg'

type Props = {
  gpsr: GpsrModel
  title: string
}

const GpsrInfo = ({ gpsr, title }: Props) => {
  const address = [
    gpsr.manufacturerAddress,
    [gpsr.manufacturerZipCode, gpsr.manufacturerCity].filter(Boolean).join(' '),
    gpsr.manufacturerCountryName,
  ].filter(Boolean).join(', ')

  return (
    <div className={styles.component}>
      <h3 className={styles.sectionHeading}>{title}</h3>
      <div className={styles.name}>{gpsr.manufacturerName}</div>
      {address && (
        <div className={styles.field}>
          <MapPinIcon className={styles.icon} />
          <span>{address}</span>
        </div>
      )}
      {gpsr.manufacturerPhone && (
        <div className={styles.field}>
          <PhoneIcon className={styles.icon} />
          <a href={`tel:${gpsr.manufacturerPhone}`}>{gpsr.manufacturerPhone}</a>
        </div>
      )}
      {gpsr.manufacturerEmail && (
        <div className={styles.field}>
          <EmailIcon className={styles.icon} />
          <a href={`mailto:${gpsr.manufacturerEmail}`}>{gpsr.manufacturerEmail}</a>
        </div>
      )}
      {gpsr.manufacturerWebsite && (
        <div className={styles.field}>
          <GlobeIcon className={styles.icon} />
          <a href={gpsr.manufacturerWebsite} target="_blank" rel="noopener noreferrer">
            {gpsr.manufacturerWebsite}
          </a>
        </div>
      )}
    </div>
  )
}

export default GpsrInfo
